import { Trans, useTranslation } from "react-i18next";
import React, { useMemo, useState } from "react";
import {
  Popup,
  PopupActions,
  PopupContent,
  PopupHeading,
} from "../../components/Common/Popup";
import {
  ACTION_PATCH_USER,
  ACTION_SET_PATCHING,
  useAuth,
} from "../providers/AuthProvider";
import Button from "../../components/Common/Button";
import { Field, Form, Formik } from "formik";
import FormikTextField from "../../components/Common/FormikTextField";
import * as Yup from "yup";
import { getYUPValidators } from "../../components/yupvalidators";
import LoadingButton from "../../components/LoadingButton";
import { usePictureSets } from "../hooks/usePictureSets";
import EpmsImage from "../../components/Common/EpmsImage";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { callAPI } from "../../lib/common";

const useStyles = makeStyles({
  favoriteContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    "& img": {
      maxWidth: "100%",
      maxHeight: "30vh",
    },
  },
});

const UpdateMobilePhoneDialog = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const { update, currentPictureSet } = usePictureSets();
  const [isSaving, setIsSaving] = useState(false);

  const favorite = useMemo(() => {
    return currentPictureSet.pictures.find(
      (ps) => ps.keywords.indexOf("favorite") >= 0
    );
  }, [currentPictureSet]);

  return (
    <Popup onClose={props.onClose}>
      <Formik
        initialValues={{
          fullName: "",
        }}
        validateOnMount={true}
        validationSchema={schema(t)}
        onSubmit={(values) => {
          setIsSaving(true);
          callAPI(
            "/api/webshop/user/picture-sets/" + currentPictureSet.subject.uuid,
            "PATCH",
            values
          ).then(() => {
            update();
          });
        }}
      >
        {({ submitForm, isValid, isSubmitting }) => {
          return (
            <Form>
              <PopupContent>
                {favorite && (
                  <div className={classes.favoriteContainer}>
                    <EpmsImage uuid={favorite.uuid} size={320} lockedSize />
                  </div>
                )}
                <Field
                  label={t("Full name")}
                  name="fullName"
                  component={FormikTextField}
                  variant="outlined"
                />
                <p>
                  <Trans>
                    To keep track of all of your added picture sets we ask you
                    to kindly provide the full name of the person in this
                    picure.
                  </Trans>
                </p>
              </PopupContent>

              <PopupActions>
                <LoadingButton
                  isLoading={isSaving}
                  fullWidth
                  disabled={!isValid}
                >
                  {t("Save")}
                </LoadingButton>
              </PopupActions>
            </Form>
          );
        }}
      </Formik>
    </Popup>
  );
};

const schema = (t) => () => {
  const validators = getYUPValidators(t);
  return Yup.object().shape({
    fullName: validators.FULL_NAME.required(t("This is required!")),
  });
};

export default UpdateMobilePhoneDialog;
